import { createElement } from 'react';

/**
 * Creates a react component that renders one of the definition elements depending on the "style" property.
 * The default (no style is provided) is to render the 'default' definition.
 *
 * @param {object} definitions
 * @return {Function<Element>}
 */
export const chooseFlavor = definitions => {
  // a component
  return ({ flavor, children, ...rest }) => {
    flavor = flavor || 'default';

    const toRender = definitions[flavor];
    if (!toRender) {
      throw new Error(`unknown style: ${flavor}`);
    }

    return createElement(toRender, rest, children);
  };
};
